export default __webpack_public_path__ + "static/media/icon-button-settings.2e36dbdd.svg";